export default {
  footer: {
    tagline: 'Plataforma de gestión de entregas con IA que ayuda a las empresas a automatizar el despacho, optimizar rutas y encantar a los clientes.',
    aiCommandHint:
      'Centro de comando IA: asignación autónoma a transportistas y conductores, rutas con agentes, alertas inteligentes y agentes IA en una sola torre de control.',
    product: 'Producto',
    builtFor: 'Por sector',
    resources: 'Recursos',
    company: 'Empresa',
    compare: 'Comparar',
    links: {
      compareHub: 'Comparar todas las plataformas',
      howItWorks: 'Cómo funciona',
      brandedTracking: 'Seguimiento con marca',
      routePlanner: 'Planificador de rutas',
      aiAgents: 'Agentes IA',
      autoAllocation: 'Asignación automática',
      driverApp: 'App del conductor',
      cashManagement: 'Gestión de efectivo',
      proofOfDelivery: 'Prueba de entrega',
      reportsAnalytics: 'Informes y análisis',
      restaurants: 'Restaurantes y QSR',
      pharmacies: 'Farmacias',
      retail: 'Retail',
      ecommerce: 'E-commerce',
      couriers: 'Mensajería y logística',
      grocery: 'Supermercados',
      allIndustries: 'Todos los sectores',
      caseStudies: 'Casos de éxito',
      blog: 'Blog',
      roiCalculator: 'Calculadora ROI',
      whitepapers: 'Whitepapers',
      aboutUs: 'Sobre nosotros',
      pricing: 'Precios',
      partners: 'Socios',
      integrations: 'Integraciones',
      contact: 'Contacto',
      altRoutific: 'Alternativa a Routific',
      altShipday: 'Alternativa a Shipday',
      altOnfleet: 'Alternativa a Onfleet',
      altTookan: 'Alternativa a Tookan',
      altCircuit: 'Alternativa a Circuit',
      altOptimoroute: 'Alternativa a OptimoRoute',
      altRoute4me: 'Alternativa a Route4Me',
      altBringg: 'Alternativa a Bringg',
      altDetrack: 'Alternativa a Detrack',
      altLocus: 'Alternativa a Locus',
      altDispatchtrack: 'Alternativa a DispatchTrack',
      altTrackPod: 'Alternativa a Track-POD',
      altUpper: 'Alternativa a Upper',
      altZeo: 'Alternativa a Zeo',
    },
    language: 'Idioma',
    terms: 'Términos de servicio',
    privacy: 'Política de privacidad',
    rights: 'Todos los derechos reservados.',
    location: { title: 'Nuestra sede', eyebrow: 'Sede central', hq: 'Sede de Geofleet', cta: 'Abrir en Maps', contact: 'Contáctanos' },
  },
};
